import { User } from "@prisma/client";
import PillTag from "components/generic-building-blocks/pills/PillTag";
import { DateTime } from "luxon";
import React from "react";

interface Props {
  title: string;
  description?: string;
  explainer?: string;
  user: Pick<User, "firstName" | "lastName" | "image">;
  tag?: string;
  updatedAt: string | Date;
}

export default function SelectorListItem({ title, description, explainer, user, tag, updatedAt }: Props): JSX.Element {
  return (
    <div className="px-6 min-h-[50px] flex flex-wrap flex-grow justify-between">
      <div className="flex flex-row gap-x-4">
        <div className="my-auto">
          <h3 className="text-base font-semibold text-gray-900">{title}</h3>
          {description && <div className="text-sm text-gray-500">{description}</div>}

          {explainer && (
            <div className="mt-1 font-medium overflow-x-auto gap-x-2 items-center text-gray-500 text-xs justify-start flex flex-row show-scrollbar">
              {explainer}
            </div>
          )}
        </div>
      </div>
      <div className="flex flex-row gap-x-10">
        <div>
          <div className="mt-2 ml-auto flex justify-end text-sm text-gray-500">
            <img className="w-6 h-6 border rounded-full shadow-xs" alt={`${user.firstName} ${user.lastName}`} src={user.image ?? undefined} />
            <div className="pl-2 pr-4 flex text-md font-semibold text-gray-900">{user.firstName}</div>
            {tag ? <PillTag body={tag} /> : null}
          </div>
          <div className="pt-2 text-sm text-gray-500">
            Last edited on
            <time dateTime="2020-09-19" className="ml-1">
              {DateTime.fromJSDate(new Date(updatedAt)).toLocaleString({ month: "long", day: "numeric", year: "numeric" })}
            </time>
          </div>
        </div>
      </div>
    </div>
  );
}
